export const validation = {
  headingMaxChar: 120,
  paragraphMaxChar: 1500,
  title: { required: true }
}
